var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"data-cy":"copy_to_clipboard","x-small":"","icon":""},on:{"click":function($event){return _vm.copyToClipboard()}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v("mdi-content-copy")])],1)]}}])},[_c('span',[_vm._v("Copy to Clipboard")])])}
var staticRenderFns = []

export { render, staticRenderFns }